'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getClientStorage = require('@narvar/client-storage');
var client = require('@apollo/client');
var apollo3CachePersist = require('apollo3-cache-persist');
var apolloClientFactory = require('./apolloClientFactory.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var getClientStorage__default = /*#__PURE__*/_interopDefaultLegacy(getClientStorage);

const apolloClientFactoryUnpersisted = ({
  name,
  connectToDevTools,
  uri,
  maxRetryAttempts,
  maxBatch,
  batchInterval,
  cacheTtlMins,
  cacheTtlCheckMs,
  restLinks,
  fetch,
  ssrMode,
  link,
  disablePersistedCache,
  initialState,
  addTypename,
  possibleTypes,
  typePolicies
} = {}) => apolloClientFactory["default"]({
  name,
  connectToDevTools,
  uri,
  maxRetryAttempts,
  maxBatch,
  batchInterval,
  cacheTtlMins,
  cacheTtlCheckMs,
  restLinks,
  fetch,
  ssrMode,
  link,
  disablePersistedCache,
  initialState,
  addTypename,
  possibleTypes,
  typePolicies
});
const apolloClientFactoryPersisted = async ({
  name,
  connectToDevTools,
  uri,
  maxRetryAttempts,
  maxBatch,
  batchInterval,
  cacheTtlMins,
  cacheTtlCheckMs,
  restLinks = {},
  fetch,
  ssrMode = false,
  link,
  disablePersistedCache = false,
  initialState,
  addTypename,
  possibleTypes,
  typePolicies
} = {}) => {
  let cache = new client.InMemoryCache({
    addTypename,
    possibleTypes,
    typePolicies
  });
  if (initialState) {
    cache = cache.restore(initialState);
  }
  const clientStorage = getClientStorage__default["default"]();
  let persistor = null;
  if (typeof window === 'object' && clientStorage && !disablePersistedCache) {
    persistor = new apollo3CachePersist.CachePersistor({
      cache,
      storage: clientStorage
    });
    await persistor.restore();
  }
  return apolloClientFactory["default"]({
    name,
    connectToDevTools,
    uri,
    maxRetryAttempts,
    maxBatch,
    batchInterval,
    cacheTtlMins,
    cacheTtlCheckMs,
    restLinks,
    fetch,
    ssrMode,
    link,
    disablePersistedCache,
    initialState,
    addTypename,
    possibleTypes,
    cache,
    persistor
  });
};

exports.CACHE_TTL_CHECK_MS = apolloClientFactory.CACHE_TTL_CHECK_MS;
exports.CACHE_TTL_MINS = apolloClientFactory.CACHE_TTL_MINS;
exports.apolloClientFactory = apolloClientFactoryUnpersisted;
exports["default"] = apolloClientFactoryPersisted;
